import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accepter-devis-negoce',
  templateUrl: './accepter-devis-negoce.component.html',
  styleUrls: ['./accepter-devis-negoce.component.scss']
})
export class AccepterDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
